// extracted by mini-css-extract-plugin
export default {"div-banner":"GenericBanner_div-banner__fmrbT","text-overlay":"GenericBanner_text-overlay__dFoIW"};